module.exports = __webpack_public_path__ + "static/img/9.18d4661.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/zh/9.png
// module id = 8vCl
// module chunks = 0